import { useQuery } from "@tanstack/react-query";
import { DropsApi } from "@devour/client";
import getConfig from "@/utils/getConfig";

export function useGetDropTikTokVideos(slug?: string) {
    return useQuery({
        queryKey: ["drop-tiktok-videos", slug],
        queryFn: async () => {
            if (!slug) return null;
            const api = new DropsApi(getConfig());
            return (api as any).getDropsSlugSlugContentTiktokVideos({ slug });
        },
        enabled: Boolean(slug),
        staleTime: 60 * 60 * 1000,
    });
}
